import { render, staticRenderFns } from "./AddUsers.vue?vue&type=template&id=60df4882&scoped=true&"
import script from "./AddUsers.vue?vue&type=script&lang=js&"
export * from "./AddUsers.vue?vue&type=script&lang=js&"
import style0 from "./AddUsers.vue?vue&type=style&index=0&id=60df4882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60df4882",
  null
  
)

export default component.exports